/**
 * 配置Ajax
 */
import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import { getLocalStorage } from '@/assets/js/storage';
import { createHashHistory } from 'history';
import { message, Spin } from 'antd';
import loadingImg from '../image/loading.gif';
import customErrorTipsCodes from './customErrorTipsCodes';

const history = createHashHistory();
export default function () {
    let _prefix = '';
    let _token = '';
    let requestCount = 0;//请求数量
    const showLoading = () => {
        if (requestCount === 0) {
            let renderDom = document.createElement('div');
            renderDom.setAttribute('id', 'requestLoading');
            document.body.appendChild(renderDom);
            ReactDOM.render(<Spin size='large' indicator={<img style={{ width: 100, height: 100, userSelect: 'none' }} src={loadingImg} />} ></Spin>, renderDom);
        }
        requestCount++;
    };//显示Spin组件

    const hideLoading = () => {
        requestCount--;
        if (requestCount === 0) {
            document.body.removeChild(document.getElementById('requestLoading'));
        }
    };//隐藏Spin组件

    // 根据不同的环境获取响应的api域名地址
    if (process.env.NODE_ENV === 'production') {
        _prefix = `${process.env.HOST}/`;
    } else {
        _prefix = '/';
    }
    axios.defaults.baseURL = _prefix;

    // 请求超时时间为10秒
    axios.defaults.timeout = 10000;

    // 请求发送拦截，并在头部加入token
    axios.interceptors.request.use(
        function (config) {
            let nextToken = getLocalStorage('auth') && JSON.parse(getLocalStorage('auth')).token;
            if (config.url == '/?cmd=com.xqxc.api.pig.mis.biz.account.AdminLoginService.getLoginToken&group=mis') { // 如果为登录接口，重置登录信息
                _token = '';
            } else if (_token == '') {  // 第一次登录直接从缓存后去token
                _token = nextToken;
            } else {
                if (_token != nextToken) {
                    _token = '';  // 前后两次调用token不同，退出登录防止串token
                } else {
                    _token = nextToken;
                }
            }
            if (_token) {
                config.headers['token'] = `${_token}`; // 存在将token写入请求头
            }
            if (config.headers.isLoading !== false) showLoading();
            return config;
        },
        function (error) {
            if (error.config.headers.isLoading !== false) hideLoading();
            return Promise.reject(error);
        }
    );

    // 请求结果拦截，根据不同的错误码触发相应操作
    axios.interceptors.response.use(
        function (response) {
            try {
                if (response.data.errCode != 0) {
                    // 以下不合法code跳转登录页，其中3004刷新com.xqxc.api.pig.mis.biz.account.AdminLoginService.refreshToken 后续优化
                    if (response.data.errCode == 3001 || response.data.errCode == 3002 || response.data.errCode == 3003 || response.data.errCode == 3004 || response.data.errCode == 3005 || response.data.errCode == 3006) {
                        // token失效
                        message.error('账号过期或异地登录，系统将在 2 秒钟后跳转登录页，请重新登录');
                        history.push({ pathname: '/login', state: { pageInfo: '' } });
                        setTimeout(() => { window.location.reload(); }, 2000);
                    } else {
                        // 接口错误
                        if(customErrorTipsCodes.includes(response.data.errCode)){
                            // nothing to do at here;
                        }else if (response.data.errDesc) {
                            message.error(response.data.errDesc);
                        } else if (response.data.errName) {
                            message.error(response.data.errName);
                        } else {
                            message.error('接口' + response.data.errCode + '错误：【' + response.config.url + '】');
                        }
                    }
                }
            } catch (e) {
                message.error('后台' + response.data.errCode + '错误返回格式不正确');
            }
            if (response.config.headers.isLoading !== false) hideLoading();
            return response;
        },
        function (error) {
            if (error.config.headers.isLoading !== false) hideLoading();
            if (error.response) {
                switch (error.response.data.status) {
                    case 3003:
                        // 账号被重复登录
                        message.error('账号其它地方被重复登录');
                        history.push({ pathname: '/login', state: { pageInfo: '' } });
                        setTimeout(() => { window.location.reload(); }, 2000);
                        break;
                    case 3004:
                        // token失效
                        message.error('由于您多点登录或长时间未操作，请重新登录');
                        history.push({ pathname: '/login', state: { pageInfo: '' } });
                        setTimeout(() => { window.location.reload(); }, 2000);
                        break;
                    case 500:
                        // 500 服务端请求错误
                        message.error('接口500错误：【' + error.response.data.path + '】');
                        return Promise.reject(error.response);
                    case 404:
                        // 找不到资源
                        message.error('接口404错误：【' + error.response.data.path + '】');
                        return Promise.reject(error.response);
                    default:
                        return Promise.reject(error.response);
                }
            }
        }
    );
}

// 提供给第三方嵌入系统，实现跳转至登录页
export const junpToLogin = () => {
    history.push({ pathname: '/', state: { pageInfo: '' } }); // 账号被重复登录
};